<template>
  <with-actions>
    <div class="form-inline ml-auto" slot="context-actions">
      <router-link class="btn btn-success" :to="{ name: 'product' }" tag="button">{{
        'routes_product_create' | t
      }}</router-link>
    </div>
    <div class="card">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>{{ 'title' | t }}</th>
            <th>{{ 'description' | t }}</th>
            <th>{{ 'price' | t }}</th>
            <th>{{ 'product_type' | t }}</th>
            <th>{{ 'billing_product_id' | t }}</th>
          </tr>
        </thead>
        <tbody>
          <router-link
            :to="{ name: 'edit_product', params: { product_id: product.id } }"
            tag="tr"
            v-for="product in products"
            :key="product.id"
            role="button"
          >
            <td>{{ title(product) }}</td>
            <td>{{ description(product) }}</td>
            <td>{{ price(product).price }} {{ price(product).currency }}</td>
            <td>{{ product.product_type | t }}</td>
            <td>{{ product.billing_product_id }}</td>
          </router-link>
        </tbody>
      </table>
    </div>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';

export default {
  data: function () {
    return {
      products: []
    };
  },
  methods: {
    title(product) {
      return product.descriptions[0].title;
    },
    description(product) {
      return product.descriptions[0].description;
    },
    price(product) {
      return product.prices[0];
    }
  },
  mounted: function () {
    this.setBreadcrumbs([{ to: { name: 'products' }, text: 'Products' }]);
    Api.findAllPages('products').then(({ data }) => {
      this.products = data;
    });
  }
};
</script>

<style scoped></style>
